module.exports = __webpack_public_path__ + "img/bookmark.518553be.svg";